import React from 'react'
import leasingi from '../assets/leasingi.jpg'
import kredytyfirmowe from '../assets/kredytyfirmowe.jpg'
import pozyczkiunijne from '../assets/pozyczkiunijne.jpg'
import kredytyhipoteczne from '../assets/kredytyhipoteczne.jpg'
import {BsFillArrowDownCircleFill} from 'react-icons/bs'

import { Link } from 'react-router-dom'

const ofertaItems = [
    {
        id: 1,
        text: "Leasingi",
        text2: "Finansowanie pojazdów oraz maszyn.",
        to: "/leasingi",
        img: leasingi,
    },  {
        id: 2,
        text: "Kredyty Firmowe",
        text2: "Uzyskanie środków na prowadzenie/ rozwój Twojej firmy.",
        to: "/kredytyfirmowe",
        img: kredytyfirmowe,
    },  {
        id: 3,
        text: "Pożyczki/ dotacje unijne",
        text2: "Najtańsza forma pozyskania środków inwestycyjnych.",
        to: "/pozyczkiunijne",
        img: pozyczkiunijne,
    },  {
        id: 4,
        text: "Kredyty hipoteczne",
        text2: "Finansowanie zakupu nieruchomości.",
        to: "/kredytyhipoteczne",
        img: kredytyhipoteczne,
    }, 
]

const Oferta = () => {
  return (
    <div className='w-full'>
        <div className='justify-center flex mx-auto max-w-[1450px] bg-white'>
            <div className='text-center mx-10'>
                <h1 className='text-4xl md:text-6xl uppercase font-bold pt-14 text-[#4C4C9B]'>Oniko-Expert</h1>
                <p className='pt-3 text-sm sm:text-base'>Jesteśmy rzetelną firmą zarejestrowaną w Komisji Nadzoru Finansowego.
                Zaufaj doświadczeniu i wiedzy naszych ekspertów.</p>

                <div className='grid sm:grid-cols-2 lg:grid-cols-4 sm:pt-20'>
                {ofertaItems.map((item) => (
                    <div key={item.id} className='mx-6 bg-gray-50 rounded-2xl py-10 px-2 hover:shadow-lg duration-300 mt-10 lg:mt-5 text-sm sm:text-base'>
                        <img src={item.img} alt={item.text} className='rounded-full h-[100px] w-[100px] mx-auto object-cover'/>
                        <h2 className='font-semibold text-lg pt-1'>{item.text}</h2> 
                        <p className='py-6'>{item.text2}</p>
                        <button className='text-white bg-[#4C4C9B] py-1 px-2 rounded-lg hover:scale-95 duration-500'>
                            <Link to={item.to}>
                                <div className='flex items-center'>
                                <p className='pr-2'>Rozwiń</p>
                                <BsFillArrowDownCircleFill />
                                </div>
                            </Link>
                        </button>
                    </div>    
                ))}
                </div>
            </div>       
        </div>
    </div>
  )
}

export default Oferta